import { render, staticRenderFns } from "./outside-amount.vue?vue&type=template&id=368d7a7a&scoped=true&"
import script from "./outside-amount.vue?vue&type=script&lang=js&"
export * from "./outside-amount.vue?vue&type=script&lang=js&"
import style0 from "./outside-amount.vue?vue&type=style&index=0&id=368d7a7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d7a7a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
